// export const rootUrl = 'http://localhost:8081/guest-queue';
export const rootUrl = process.env['NX_WAIVER_API_URL'] || 'http://localhost:8080';

// export const sseRootUrl = process.env['NX_SSE_API_URL'] || 'http://localhost:8080';
